import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}/our-services`; // Replace with your actual API URL

const customHeaders = {
  'Content-Type': 'application/json',
};

// Fetch all room services with pagination
export const fetchOurServicesTable = async (page: number, limit: number) => {
  const response = await axios.get(`${API_URL}/table?page=${page}&limit=${limit}`, { headers: customHeaders });
  return response.data;
};

// Fetch all Our services
export const fetchOurServices = async () => {
  const response = await axios.get(API_URL, { headers: customHeaders });
  return response.data;
};

// Fetch a Our service by ID
export const fetchOurServiceById = async (id: string) => {
  const response = await axios.get(`${API_URL}/${id}`, { headers: customHeaders });
  return response.data;
};

// Create a new Our service
export const addOurService = async (newOurService: { name: string; description: string; photo: string }) => {
  const response = await axios.post(API_URL, newOurService, { headers: {
    'Content-Type': 'multipart/form-data', // If photo is included as a file
  } });
  return response.data;
};

// Edit an existing Our service
export const updateOurService = async (id: string, updatedOurService: { name: string; description: string; photo?: string }) => {
  const response = await axios.put(`${API_URL}/${id}`, updatedOurService, { headers: {
    'Content-Type': 'multipart/form-data', // If photo is included as a file
  } });
  return response.data;
};

// Delete a Our service
export const removeOurService = async (id: string) => {
  const response = await axios.delete(`${API_URL}/${id}`, { headers: customHeaders });
  return response.data;
};
